import { FC } from 'react';
import { ContinueButtonProps } from './continueButton.type';
import { getIdAttributes } from '../../utils/helper';

export const idPrefix: string = 'continue-button';

const ContinueButton: FC<ContinueButtonProps> = ({
  accepted,
  onClick,
  children,
}) => {
  return (
    <button
      {...getIdAttributes(idPrefix, 'container')}
      onClick={onClick}
      disabled={!accepted}
      className={`px-40 py-2 rounded-[30px] text-white transition ${
        accepted
          ? 'bg-THEME_COLOR hover:bg-THEME_HOVER_COLOR'
          : 'bg-gray-300 cursor-not-allowed'
      }`}
    >
      {children}
    </button>
  );
};

export default ContinueButton;
